import { render, staticRenderFns } from "./BaseCog.vue?vue&type=template&id=57bd5b98&scoped=true&"
import script from "./BaseCog.vue?vue&type=script&lang=ts&"
export * from "./BaseCog.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCog.vue?vue&type=style&index=0&id=57bd5b98&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd5b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
